import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";

import ProfileIcon from "../assets/icons/profile";
import Logo from "../assets/image/Logo.png";
import { routes } from "../contant";
import {
  getUserUnReadNotification,
  getUserReadNotification,
  deActiveUserNotification,
  getProfile,
} from "../redux/action/auth";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { profile, getUserNotify } = useSelector((state) => state.auth);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notificationType, setNotificationType] = useState("unread");
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  const notificationRef = useRef(null);
  const profileDropdownRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getUserUnReadNotification());
      dispatch(getProfile());
    }
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setIsProfileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleNotifications = () => setShowNotifications((prev) => !prev);
  const toggleProfileDropdown = () => setIsProfileDropdownOpen((prev) => !prev);
  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate(routes.signin);
  };

  const fetchNotification = (type) => {
    setNotificationType(type);
    dispatch(
      type === "unread"
        ? getUserUnReadNotification()
        : getUserReadNotification()
    );
  };

  const getDaysAgo = (date) => {
    const diff = new Date() - new Date(date);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    if (days === 0) return "Today";
    const years = Math.floor(days / 365);
    const months = Math.floor((days % 365) / 30);
    const remainingDays = days % 30;

    return (
      [
        years ? `${years}y` : "",
        months ? `${months}m` : "",
        remainingDays ? `${remainingDays}d` : "",
      ]
        .filter(Boolean)
        .join(" ") + " ago"
    );
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md px-4 py-2 flex justify-between items-center">
      <ToastContainer />

      <a href="https://leadgenpro.in" target="_blank" rel="noopener noreferrer">
        <img src={Logo} alt="Logo" className="h-10 xl:h-14" />
      </a>

      <button
        className="lg:hidden text-gray-700 text-2xl"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        &#9776;
      </button>

      <nav
        className={`${
          isMenuOpen ? "block" : "hidden"
        } lg:flex flex-col lg:flex-row absolute lg:static bg-white lg:bg-transparent w-full lg:w-auto top-full left-0 p-4 lg:p-0`}
      >
        <ul className="flex flex-col lg:flex-row items-center gap-4 lg:gap-6">
          <li>
            <button
              onClick={() => navigate(routes.dashboard)}
              className="hover:text-black"
            >
              Dashboard
            </button>
          </li>

          {isAuthenticated ? (
            <>
              <li>
                <button
                  onClick={() =>
                    window.open("https://leadgenpro.in/articles", "_blank")
                  }
                  className="hover:text-black"
                >
                  Article
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigate("/lead")}
                  className="hover:text-black"
                >
                  Leads
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/renewpage")}
                  className="hover:text-black"
                >
                  Renewals
                </button>
              </li>
              <li>
                <Link
                  to={routes.quotation}
                  onClick={() => {
                    ["vehicleData", "vehicleFormFiles", "vehicle3Data"].forEach(
                      (key) => localStorage.removeItem(key)
                    );
                  }}
                  className="text-[#56D9B9] font-semibold hover:text-teal-600"
                >
                  Generate Quotation
                </Link>
              </li>
            </>
          ) : (
            <>
              <li>
                <button
                  onClick={() => navigate("/about-us")}
                  className="hover:text-black"
                >
                  About Us
                </button>
              </li>
              <li>
                <Link
                  to={routes.signin}
                  className="text-[#56D9B9] font-semibold hover:text-teal-600"
                >
                  Become Pro Lead Partner
                </Link>
              </li>
            </>
          )}
        </ul>
      </nav>

      <div className="relative flex items-center space-x-4">
        {isAuthenticated ? (
          <>
            <div className="relative" ref={notificationRef}>
              <button
                onClick={toggleNotifications}
                className="text-lg relative"
              >
                <i className="fa fa-bell"></i>
                {notificationType === "unread" && getUserNotify?.length > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center">
                    {getUserNotify.length}
                  </span>
                )}
              </button>

              {showNotifications && (
                <div className="absolute right-0 mt-2 w-80 max-h-80 overflow-y-auto bg-white shadow-lg rounded-lg z-50">
                  <div className="flex border-b">
                    {["unread", "read"].map((type) => (
                      <button
                        key={type}
                        onClick={() => fetchNotification(type)}
                        className={`flex-1 py-2 text-sm text-center font-medium ${
                          notificationType === type
                            ? "border-b-2 border-blue-500"
                            : ""
                        }`}
                      >
                        {type.charAt(0).toUpperCase() + type.slice(1)}
                      </button>
                    ))}
                  </div>

                  <div className="p-4">
                    {notificationType === "unread" && (
                      <div className="mb-2">
                        <label className="inline-flex items-center space-x-2">
                          <input
                            type="checkbox"
                            className="form-checkbox"
                            onChange={(e) =>
                              e.target.checked &&
                              dispatch(deActiveUserNotification())
                            }
                          />
                          <span className="text-sm">Mark All Read</span>
                        </label>
                      </div>
                    )}

                    {getUserNotify?.length > 0 ? (
                      getUserNotify.map((note, i) => (
                        <div
                          key={i}
                          className="p-2 mb-2 border rounded bg-gray-50"
                        >
                          <div className="flex justify-between text-sm">
                            <strong>{note.notificationType}</strong>
                            <span className="text-xs text-gray-500">
                              {getDaysAgo(note.notificationAt)}
                            </span>
                          </div>
                          <p className="text-sm mt-1 text-gray-700">
                            {note.discription}
                          </p>
                        </div>
                      ))
                    ) : (
                      <p className="text-sm text-gray-500">No notifications</p>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="relative" ref={profileDropdownRef}>
              <button
                onClick={toggleProfileDropdown}
                className="focus:outline-none"
              >
                {profile?.profilePhoto ? (
                  <img
                    src={profile.profilePhoto}
                    alt="Profile"
                    className="w-10 h-10 object-cover rounded-full border-2 border-white"
                  />
                ) : (
                  <ProfileIcon className="w-10 h-10 text-gray-500" />
                )}
              </button>

              {isProfileDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg z-50">
                  <ul className="py-2">
                    <li>
                      <Link
                        to={routes.profile}
                        className="block px-4 py-2 hover:bg-gray-100"
                      >
                        Profile
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={routes.lead}
                        className="block px-4 py-2 hover:bg-gray-100"
                      >
                        My Request
                      </Link>
                    </li>
                    <li>
                      <button
                        onClick={() => navigate(routes.dashboard)}
                        className="w-full text-left px-4 py-2 hover:bg-gray-100"
                      >
                        Dashboard
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-2 hover:bg-gray-100"
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <Link
              to={routes.signup}
              className="text-sm text-blue-600 hover:underline"
            >
              Signup
            </Link>
            <Link
              to={routes.signin}
              className="text-sm text-blue-600 hover:underline"
            >
              Login
            </Link>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
